import InputsMeasures from "./InputsMeasures";
export default InputsMeasures;
